
import React from 'react';
import { Button } from '@/components/ui/button';
import { formatDate } from '@/lib/utils';
import { ExternalLink } from 'lucide-react';

interface NewsletterFeaturedIssueProps {
  date: string;
  title: string;
  url: string;
  highlights: string[];
  image?: string;
}

const NewsletterFeaturedIssue: React.FC<NewsletterFeaturedIssueProps> = ({ date, title, url, highlights, image }) => {
  return (
    <div className="relative bg-white border border-neutral-light rounded-xl shadow-lg p-6 animate-pulse-slow">
        <div className="flex items-center gap-2 mb-6">
          <div className="h-8 w-8 bg-primary rounded-full flex items-center justify-center">
            <span className="text-white font-bold text-sm">TT</span>
          </div>
          <span className="text-lg font-bold gradient-text">Talent Tales</span>
          <span className="ml-auto text-sm text-gray-600">{formatDate(new Date(date))}</span>
        </div>
        
        {image && (
          <div className="w-full h-40 mb-4 overflow-hidden rounded-md">
            <img 
              src={image} 
              alt={title}
              className="w-full h-full object-cover"
              width="400"
              height="240"
              loading="eager" // Load this eagerly as it's a key above-the-fold image
            />
          </div>
        )}
        
        <h3 className="text-xl font-bold mb-4">{title}</h3>
        <div className="space-y-3 mb-4">
          {highlights.map((highlight, index) => (
            <div key={index} className="flex gap-2 items-start">
              <div className="h-2 w-2 mt-2 rounded-full bg-primary"></div>
              <p className="text-sm text-secondary-dark flex-1">{highlight}</p>
            </div>
          ))}
        </div>
        <div className="text-center">
          <a href={url} target="_blank" rel="noopener noreferrer">
            <Button className="bg-primary text-white hover:bg-primary-light">
              Read full issue <ExternalLink className="h-4 w-4 ml-2" />
            </Button>
          </a>
        </div>
      </div>
  );
};

export default NewsletterFeaturedIssue;

